/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_Portals_ExtraInputs */

const cs_property_section_portals_extra = /** @type {(inputs: Property_Section_Portals_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portály a VR`)
};

const en_property_section_portals_extra = /** @type {(inputs: Property_Section_Portals_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal & VR extras`)
};

/**
* | output |
* | --- |
* | "Portal & VR extras" |
*
* @param {Property_Section_Portals_ExtraInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_portals_extra = /** @type {((inputs?: Property_Section_Portals_ExtraInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_Portals_ExtraInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_portals_extra(inputs)
	return cs_property_section_portals_extra(inputs)
});